import styles from './style.module.css';
import { useEffect,useState,useRef } from 'react';
import { useRecoilState} from 'recoil';
import { newTaskConfig, namespaceState } from '../../recoil/atoms';
import useApi from '../../services/useApi';
import NewTaskHeader from '../../compoenets/NewTaskHeader';
import Table from '../../compoenets/Table';
import NaviButton from '../../compoenets/NaviButton';
import getByteSize from '../../utils/getByteSize';
import dateFormat from '../../utils/dateFormat';
import EmptyModal from '../../compoenets/EmptyModal';
import ModelUploader from '../../compoenets/ModelUploader';
import ConfirmModal from '../../compoenets/ConfirmModal';
import ToolTip from '../../compoenets/ToolTip';

export default function NewTaskDataV2(){
    const userId=JSON.parse(localStorage.getItem("account")).id;
    const [taskConfig,setTaskConfig] = useRecoilState(newTaskConfig);
    const iconFullUrl=process.env.REACT_APP_NGP_SERVICE_URL.replace(/\/$/,'')+taskConfig.appData.iconUrl;
    const [nsState,] = useRecoilState(namespaceState);
    const appName=taskConfig.appData.appName;
    const [datasetList,setDatasetList]=useState(null);
    const datasetListRef=useRef(null);
    const [modelList,setModelList]=useState([]);
    const [modelListState,setModelListState]=useState(null);
    const [checkedModel,setCheckedModel]=useState([]);
    const [isUploadModal,setIsUploadModal]=useState(false);
    const [isDeleteConfirm,setIsDeleteConfirm]=useState(false);
    const [deleteModel,setDeleteModel]=useState([]);
    const [isDeleteDone,setIsDeleteDone]=useState(false);

    const handleDataset=(item)=>{
        setModelListState('loading');
        setTaskConfig((prevData) => ({
          ...prevData,
          requiredData: item.name,
        }));
        useApi.get('ngp/modelreg/mm/model/v1/modellist?namespaceId=' + nsState.id + "&packageName"+ taskConfig.appData.packageName+"&dataset="+(item.name)).then((res)=>{
          setModelList(res.data);
          setModelListState(res.data.length===0?'empty':'loaded');
        })
    }

    const refreshModelList=(updatedRequiredData=null)=>{
        setModelListState('loading');
        if(taskConfig.requiredData==='')return;
        useApi.get('ngp/modelreg/mm/model/v1/modellist?namespaceId=' + nsState.id + "&packageName"+ taskConfig.appData.packageName+ "&dataset="+(updatedRequiredData?updatedRequiredData:taskConfig.requiredData)).then((res)=>{
          setModelList(res.data);
          setModelListState(res.data.length===0?'empty':'loaded');
        })
    }

    const handleSelect=(item)=>{
        setTaskConfig((prevData) => ({
            ...prevData,
            initialModelId:item.modelId,
            initialModelName:item.name,
        }));
        return true;
    }

    const handleDeleteModel=()=>{
        useApi.delete('ngp/modelreg/mm/model/v1/model?namespaceId='+nsState.id+"&modelId="+deleteModel.map(item=>item.modelId).join(',')+"&userId="+userId).then((res)=>{
            refreshModelList();
            setDeleteModel([]);
            setIsDeleteConfirm(false);
            setCheckedModel([]);
            setIsDeleteDone(!isDeleteDone);
        })
    }

    useEffect(()=>{
        if(taskConfig.requiredData!==""){refreshModelList(taskConfig.requiredData);}
        useApi.get('/ngp/dm/device/app/data?namespaceId='+nsState.id+'&appId='+taskConfig.appData.appId).then(res=>{
            setDatasetList(res.data)
        })
        
        const el = datasetListRef.current;
        const handleWheel = (e)=>{
            if(e.deltaY !== 0){
                e.preventDefault();
                el.scrollLeft+=e.deltaY;
            }
        };
        el.addEventListener('wheel',handleWheel,{passive:false});
        return ()=>el.removeEventListener('wheel',handleWheel);
    },[])

    return(
        <div className={styles['wrap']}>
            <NewTaskHeader/>
            <div className={styles['body']}>
                <div className={styles['dataset']}>
                    <p>
                        <span style={{
                            background: `
                            radial-gradient(circle,transparent 17px, var(--color-hover) 18px),
                            ${appName==='message'?
                            `url("${iconFullUrl}") center / 28px no-repeat`:
                            appName==='experiment'?
                            `url("${iconFullUrl}") center / 28px no-repeat`:
                            `url("${iconFullUrl}") center / 28px no-repeat`
                            }`
                        }}/>
                        <span>{appName.charAt(0).toUpperCase()+ appName.slice(1)} Application Dataset</span>
                    </p>
                    <div className={styles['dataset-list']} ref={datasetListRef}>
                        {datasetList?
                        datasetList.map((item)=>
                        <button 
                        className={`
                            ${styles['dataset-item']}
                            ${taskConfig.requiredData===item.name&&styles['dataset-item-on']}
                        `}
                        onClick={()=>handleDataset(item)}
                        >
                            <p>
                                <span>{item.name}</span>
                                <span>{"Description: "+ item.dist}</span>
                            </p>
                        </button>
                        ):
                        <DatasetSkeleton/>}
                    </div>
                </div>
                <div className={styles['model']}>
                    <div className={styles['model-header']}>
                        <span>Model List</span>
                        {checkedModel.length!==0&&<button onClick={()=>{
                                setDeleteModel(checkedModel.map(idx=>modelList[idx]));
                                setIsDeleteConfirm(true);
                            }}/>}
                        <button onClick={()=>setIsUploadModal(true)}/>
                        {isUploadModal&&
                        <EmptyModal onClose={()=>setIsUploadModal(false)}>
                            <ModelUploader 
                            defaultDataset={taskConfig.requiredData}
                            onClose={()=>setIsUploadModal(false)}/>
                        </EmptyModal>
                        }
                    </div>
                    <Table
                    rowHover
                    cellWidth={`
                        84px 
                        .5fr 
                        1fr 
                        1fr 
                        .5fr 
                        .5fr 
                        100px 
                        100px 
                        100px 
                        120px
                    `}
                    className={styles['model-list']}
                    checkbox
                    onCheckChange={setCheckedModel}
                    resetCheck={isDeleteDone}
                    header={[
                        'ID',
                        'Name',
                        'Creator',
                        'Size',
                        'Date',
                        'Detail',
                        'Status',
                        'Delete',
                        'Select',
                    ]}
                    state={modelListState}
                    readyView={
                    <div className={styles['model-ready']}>

                    </div>
                    }
                    emptyView={
                    <div className={styles['model-empty']}>

                    </div>
                    }
                    row={modelList?.map((item)=>[
                        <ToolTip message={item.modelId}>
                            {item.modelId}
                        </ToolTip>,
                        item.name, 
                        item.userMail.split('@')[0], 
                        getByteSize(item.tfModel.size), 
                        dateFormat(item.createdTime).date.substring(0,11),
                        <button className={styles['model-info']} onClick={(e)=>{
                            e.stopPropagation();
                        }}/>,
                        <span className={`${item.status===0?styles['model-available']:item.status===1?styles['model-checking']:styles['model-disable']}`}/>,
                        <button className={styles['model-delete']} onClick={(e)=>{
                            e.stopPropagation();
                            setDeleteModel([item]);
                            setIsDeleteConfirm(true);
                        }}/>,
                        <NaviButton 
                        className={styles['model-select']}
                        to="/new-task-device" 
                        handleBtn={()=>handleSelect(item)}/>
                    ])}
                    />
                </div>
            </div>
            {isDeleteConfirm&&<ConfirmModal
                title="Model Delete"
                subTitle={"모델"+`${deleteModel.length>1?"들":" '"+deleteModel[0].name+"'"}`+"을 삭제하겠습니까?"}
                confirmText="Delete"
                cancelText="Cancel"
                onAction={handleDeleteModel}
                onClose={()=>setIsDeleteConfirm(false)}
            />}
        </div>
    )
}

const DatasetSkeleton=()=>{
    return(
    <>
    <button className={styles['dataset-item-skeleton']}>
        <p>
            <span/>
            <span/>
        </p>
    </button>
    <button className={styles['dataset-item-skeleton']}>
        <p>
            <span/>
            <span/>
        </p>
    </button>
    <button className={styles['dataset-item-skeleton']}>
        <p>
            <span/>
            <span/>
        </p>
    </button>
    </>
    )
}